import React from 'react';
import { Grid } from 'semantic-ui-react';
import FileUploadButton from '../../fileUploadButton';

const Images = ({ obj, onChange }) => {
  const bgImage = obj.bg_image ? obj.bg_image : null;
  const badgeImageFr = obj.badge_image_fr ? obj.badge_image_fr : null;
  const badgeImageEn = obj.badge_image_en ? obj.badge_image_en : null;

  return (
    <div>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column>
            <FileUploadButton
              id="bg_image"
              label="Image de fond"
              image={bgImage}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton
              id="badge_image_fr"
              label="Image du badge (fr)"
              image={badgeImageFr}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton
              id="badge_image_en"
              label="Image du badge (en)"
              image={badgeImageEn}
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default Images;



// WEBPACK FOOTER //
// ./src/components/form/historySlide/images.js